var _rect, _rect2, _path, _path2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "black",
    fillOpacity: 0.48
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#15131D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 25L30.126 25C30.5701 26.7252 32.1362 28 34 28C36.2091 28 38 26.2091 38 24C38 21.7909 36.2091 20 34 20C32.1362 20 30.5701 21.2748 30.126 23L19 23C18.4477 23 18 23.4477 18 24C18 24.5523 18.4477 25 19 25Z",
    fill: "#CAC6DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37 31L25.874 31C25.4299 29.2748 23.8638 28 22 28C19.7909 28 18 29.7909 18 32C18 34.2091 19.7909 36 22 36C23.8638 36 25.4299 34.7252 25.874 33L37 33C37.5523 33 38 32.5523 38 32C38 31.4477 37.5523 31 37 31Z",
    fill: "#CAC6DD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 4.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "url(#paint0_linear_701_30570)",
    strokeOpacity: 0.15
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_701_30570",
    x1: 28,
    y1: 4,
    x2: 28,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.560128,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndone);
export default __webpack_public_path__ + "static/media/undone.c6dc914dfe6c57207f65821bb56174ea.svg";
export { ForwardRef as ReactComponent };